import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para atualizar o status da reserva

export const atualizarReservaStatusService = async (
  reservaId: number | null,
  status: string
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva/${reservaId}`;
    const values = {
      statusReserva: status,
    };

    try {
      const response = await axios.patch(URL, values, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  return false;
};

export {};
